import { helpers } from '@vuelidate/validators'

export const fileSizeValidator = (sizeMb) =>
  helpers.withParams({ type: 'fileSizeValidator', sizeMb }, value => {
    if (!value) {
      return true
    }
    let fileSize = (sizeMb * 1024 * 1024)
    return (value.size < fileSize)
  })

export const minimumFileSizeValidator = (value) => {
  if (!value) {
    return true
  }
  return (value.size > 0)
}
